import {
  Badge,
  BadgeSize,
  BadgeVariant,
  Checkbox,
  CheckboxSize
} from "shared/components";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { BrandingTarget } from "types/landlord/address";
import { PMSNames } from "views/settings-integration/integrations/pms/constants";
import { getTargetName, pmsSyncedFields } from "./helpers";

export const PropertyChecklistRow = ({
  target,
  checked,
  onToggle
}: {
  target: BrandingTarget;
  checked: boolean;
  onToggle: () => void;
}) => {
  const dictionary = useUnitsPropertiesDictionary();
  const syncedCount = pmsSyncedFields(target).length;
  const pmsLabel = target.pms_name ? PMSNames[target.pms_name] : "PMS";

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="min-w-0">
        <Checkbox
          checked={checked}
          id={`branding-target-${target.id}`}
          label={getTargetName(target, dictionary)}
          onChange={onToggle}
          size={CheckboxSize.SM}
        />
        <p className="truncate pl-6 text-sm text-content-400">
          {target.address || "No address"}
        </p>
      </div>

      <div className="flex shrink-0 items-center gap-2">
        {target.has_existing_branding ? (
          <Badge size={BadgeSize.SM} variant={BadgeVariant.WARNING}>
            Has its own branding
          </Badge>
        ) : null}
        {syncedCount > 0 ? (
          <Badge size={BadgeSize.SM} variant={BadgeVariant.BASE}>
            {pmsLabel} · {syncedCount} landlord{" "}
            {syncedCount === 1 ? "field" : "fields"} synced
          </Badge>
        ) : null}
      </div>
    </div>
  );
};
